import Card from '@components/Card';
import { useEvent } from '@lib/hooks';
import { EntryCardProps } from './EntryCard';

export type EventCardProps = EntryCardProps<'event'>;

export const EventCard = ({ item, ...props }: EventCardProps) => {
  const {
    eventDateFormatted,
    uri: href,
    title,
    entrySummary: description,
    entryImage: image,
    priceDescription,
    dateDescription,
  } = useEvent(item);

  const eventMeta: string[] = [];

  if (eventDateFormatted) eventMeta.push(eventDateFormatted);

  return (
    <Card
      {...props}
      item={{
        href,
        title,
        meta: eventMeta,
        description,
        image,
      }}>
      <Card.Image ratio="landscape" transform="landscapeSmCrop" />
      <Card.Body cx={{ pX: 'xs', pT: 'md' }}>
        <Card.Meta bold cx={{ mB: '3xs' }} />
        <Card.Title variant="h6" cx={{ mB: '3xs' }} />
        <Card.Meta
          cx={{
            mY: '3xs',
          }}>
          {dateDescription ?? false}
        </Card.Meta>
        <Card.Description
          maxChars={100}
          cx={{
            mY: '3xs',
          }}
        />
        <Card.Meta
          cx={{
            mT: '3xs',
            mB: 'xs',
          }}>
          {priceDescription ?? false}
        </Card.Meta>
      </Card.Body>
      <Card.Foot cx={{ pX: 'xs', pB: 'md' }}>
        <Card.Cta variant="outlined" size="small" endIcon="arrowRight" />
      </Card.Foot>
    </Card>
  );
};
